import type { CSSProperties } from 'react';

/** CSS class name for native scrollbar styling (defined in sky-scrollbar.css) */
export const SKY_SCROLLBAR_CLASS = 'sky-scrollbar' as const;

export const SKY_SCROLLBAR_STYLES = {
  verticalScrollBar: {
    width: 10,
    background: 'transparent',
    borderRadius: 9999,
  },
  verticalScrollBarThumb: {
    backgroundColor: 'rgb(51 65 85)',
    borderRadius: 9999,
    border: '2px solid transparent',
    backgroundClip: 'padding-box',
  },
} as const;

/**
 * Style for the element wrapping a virtual list (antd `Listy`/`rc-virtual-list`).
 * A virtual list draws its own scrollbar thumb, which `sky-scrollbar` (native
 * `::-webkit-scrollbar` only) does not reach. Its colour comes from this
 * variable, so a virtual list gets the same thumb as the native ones.
 */
export const SKY_VIRTUAL_SCROLLBAR_STYLE: CSSProperties &
  Record<'--rc-virtual-list-scrollbar-bg', string> = {
  '--rc-virtual-list-scrollbar-bg': SKY_SCROLLBAR_STYLES.verticalScrollBarThumb.backgroundColor,
};

export default SKY_SCROLLBAR_STYLES;

export type SkyScrollBarStyles = typeof SKY_SCROLLBAR_STYLES;
